<div [formGroup]="form">
  <div class="label-input" translate>SEARCH</div>
  <div class="search">
    <i class="material-icons">search</i>
    <input
      matInput
      [formControlName]="controlName"
      [placeholder]="placeholder"
      class="form-control">
  </div>
</div>
